<template>
  <d2-container>
    <el-button
      class="filter-item"
      type="primary"
      size="mini"
      icon="el-icon-circle-plus"
      @click="add"
    >添加</el-button>
    <el-table
      size="small"
      :key="tableKey"
      stripe
      border
      highlight-current-row
      style="margin-top: 20px"
      :data="keywordList"
    >
      <el-table-column align="center" label="id">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="名称">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="规格描述">
        <template slot-scope="scope">
          <span>{{ scope.row.description }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="更新时间">
        <template slot-scope="scope">
          <span>{{ scope.row.updateTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" fixed="right" width="420">
        <template slot-scope="scope">
          <el-button
              size="small"
              type="primary"
              @click="toSpecValues(scope.row.id)"
              style="margin-top: 10px;"
          >规格值</el-button>
          <el-button
            size="small"
            type="primary"
            @click="editCard(scope.row.id)"
            style="margin-top: 10px;"
          >编辑</el-button>
          <el-button
            size="small"
            type="danger"
            @click="delCard(scope.row.id)"
            style="margin-top: 10px;"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 页码 -->
    <template slot="footer">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="listQuery.currentPage"
          :page-sizes="[10,20,30, 50]"
          :page-size="listQuery.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
      ></el-pagination>
    </template>

    <!--  添加弹窗  -->
    <el-dialog
        :title="editCardName"
        :visible.sync="dialogFormVisible"
        width="70%"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
    >
      <el-form :model="form" :rules="rules" ref="form" label-width="80px">
        <!--       选择用户  -->

        <!--     输入金额 数字    -->
        <el-form-item label="规格名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入规格名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="规格描述" prop="description">
          <el-input v-model="form.description" placeholder="请输入规格描述" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="commitForm">确 定</el-button>
      </span>
    </el-dialog>
  </d2-container>
</template>
<script>

import {
  addProductSpec,
  getProductList, getProductSpecInfo, getProductSpecList,
  removeProduct, removeProductSpec, updateProductSpec
} from '@/api/merchant/service/product'
import SelectUser from '@/components/users/selectUser.vue'

export default {
  name: 'serviceProduct',
  components: { SelectUser },
  data () {
    return {
      tableKey: 0,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '添加'
      },
      editCardName: '添加',
      total: 0,
      keyWordManger_btn_add: false,
      keyWordManger_btn_edit: false,
      keyWordManger_btn_del: false,
      dialogFormVisible: false,
      keywordList: [],
      form: {
        id: '', // id
        name: '', // 规格名称
        description: '' // 规格描述
      },
      listQuery: {
        currentPage: 1,
        pageSize: 20
      },
      listLoading: false,
      rules: {
        word: [
          {
            required: true,
            message: '关键词',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur'
          }
        ],
        color: [
          {
            required: true,
            message: '请选择背景色',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    this.getSearch()
  },
  watch: {
    $route (to, from) {
    }
  },
  methods: {
    // 每页条数
    handleSizeChange (val) {
      this.listQuery.pageSize = val
      this.getSearch(val)
    },
    // 当前页
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      this.getSearch(val)
    },
    getSearch (val) {
      let that = this
      if (val) {
        this.listQuery.currentPage = val
      } else {
        this.listQuery.currentPage = 1
      }
      getProductSpecList(this.listQuery).then(
        res => {
          that.listLoading = true
          that.keywordList = res.records
          that.total = Number(res.total)
          that.listLoading = false
        },
        err => {
          console.log('res', err)
        }
      )
    },
    add () {
      this.editCardName = '添加'
      this.dialogFormVisible = true
      this.form = {
        id: '', // id
        name: '', // 规格名称
        description: '' // 规格描述
      }
    },
    // 编辑
    editCard (id) {
      this.editCardName = '编辑'
      this.dialogFormVisible = true
      getProductSpecInfo(id).then(res => {
        this.form = res
      })
    },
    toSpecValues (id) {
      this.$router.push({
        path: '/merchant/service/product/productSpecValues',
        query: {
          id: id
        }
      })
    },
    commitForm () {
      let that = this
      this.$refs.form.validate(valid => {
        if (valid) {
          if (that.form.id) {
            // 更新
            updateProductSpec(that.form).then(res => {
              that.$message({
                message: '更新成功',
                type: 'success',
                center: true
              })
              that.dialogFormVisible = false
              that.getSearch()
            })
          } else {
            // 添加
            addProductSpec(that.form).then(res => {
              that.$message({
                message: '添加成功',
                type: 'success',
                center: true
              })
              that.dialogFormVisible = false
              that.getSearch()
            })
          }
        } else {
          return false
        }
      })
    },
    cancel () {
      let that = this
      that.dialogFormVisible = false
    },
    // 删除
    delCard (id) {
      let that = this
      this.$confirm('此操作将删除该规格, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          removeProductSpec(id).then(res => {
            that.$message({
              message: '删除成功',
              type: 'success',
              center: true
            })
            that.getSearch()
          })
        })
        .catch(() => {
          that.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  }
}
</script>
<style scoped>
.span {
  width: 50px;
  height: 50px;
  display: block;
  margin: 0px auto;
  border: 1px solid rgba(0, 0, 0, 0.3);
}
</style>
